module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Fza0"))).then(() => parcelRequire('d0iPb'));